import { Observable } from 'rxjs'; 
import { Parameter } from '../../../../@core/interfaces/common/parameter';

export interface BloodBankApprovalParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  }
 
export abstract class ApprovalModuleData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract getById(url: string,data?: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract getByType(url: string,type,typeValue): Observable<any>;
}
